import { Link } from "@inertiajs/react";
import { AlertCircle, Search } from "lucide-react";

import { Alert, AlertDescription } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { newProductPath } from "@/routes";

interface ProductCreationConfirmationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function ProductCreationConfirmationDialog({
  open,
  onOpenChange,
}: ProductCreationConfirmationDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertCircle className="h-5 w-5 text-amber-600" />
            ¿Estás seguro de crear un nuevo producto?
          </DialogTitle>
          <DialogDescription>
            Antes de crear un nuevo producto, es importante verificar que no exista uno similar en la plataforma.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <Alert className="bg-amber-50 border-amber-200">
            <Search className="h-4 w-4 text-amber-600" />
            <AlertDescription className="text-amber-800">
              Te recomendamos usar el filtro de búsqueda para verificar si el producto que necesitas ya existe en el sistema. 
              Esto ayuda a evitar duplicados y mantener el catálogo organizado.
            </AlertDescription>
          </Alert>

          <div className="space-y-2">
            <p className="text-sm font-medium">Puedes buscar por:</p>
            <ul className="list-disc list-inside space-y-1 text-sm text-muted-foreground">
              <li>Nombre del producto</li>
              <li>Código interno</li>
              <li>Categoría</li>
            </ul>
          </div>
        </div>

        <DialogFooter className="gap-2">
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            className="gap-2"
          >
            <Search className="h-4 w-4" />
            Buscar Producto
          </Button>
          <Button asChild>
            <Link href={newProductPath()}>
              Crear Producto
            </Link>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
